import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import UICloseButton from 'UIComponents/button/UICloseButton';
import H5 from 'UIComponents/elements/headings/H5';
import { useCollaborationSidebarState } from 'collaboration-sidebar';
import { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { dialogHeaderGradient } from 'automation-ui-canvas/utils/dialogHeaderGradient';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BORDER_WIDTH = 8;
const ModeIndicatorBorder = styled.div.withConfig({
  displayName: "ModeIndicator__ModeIndicatorBorder",
  componentId: "l12cwm-0"
})(["position:fixed;top:0;left:0;bottom:0;right:0;z-index:", ";pointer-events:none;", ""], URANUS_LAYER, ({
  $useGradient,
  $color,
  theme
}) => $useGradient ? // border-image's slice property cannot use the px unit and must be identical to the border width here, so we're not tokenizing it
css(["border-image:", " ", " / ", "px;"], dialogHeaderGradient, BORDER_WIDTH, BORDER_WIDTH) : `border: ${BORDER_WIDTH}px solid ${theme.color[$color]};`);
const ModeIndicatorHeader = styled.div.withConfig({
  displayName: "ModeIndicator__ModeIndicatorHeader",
  componentId: "l12cwm-1"
})(["position:fixed;top:0;left:0;z-index:", ";color:", ";padding:", ";background-size:100vw 100vh;", " border-bottom-right-radius:18px;"], URANUS_LAYER, ({
  theme
}) => theme.color['text-primary-on-fill-default'], ({
  theme
}) => `${theme.space[500]} ${theme.space[1400]} ${theme.space[500]} ${theme.space[700]}`, ({
  $useGradient,
  $color,
  theme
}) => $useGradient ? css(["background-image:", ";"], dialogHeaderGradient) : `background-color: ${theme.color[$color]};`);
const ModeIndicator = ({
  use = 'default',
  dataTestId,
  modeTitle,
  onCancel
}) => {
  const isMounted = useRef(false);
  const {
    isOpen,
    closeSidebar,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  useEffect(() => {
    if (isOpen) {
      if (isMounted.current) {
        onCancel();
      } else {
        // Closes the comment mode indicator to keep only one mode indicator active at any point of time.
        closeSidebar();
        onUpdateCollaborationSidebarState({
          isCommentModeActive: false
        });
      }
    }
  }, [closeSidebar, isOpen, onCancel, onUpdateCollaborationSidebarState]);
  useEffect(() => {
    isMounted.current = true;
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ModeIndicatorBorder, {
      $color: "fill-primary-default",
      $useGradient: use === 'preview'
    }), /*#__PURE__*/_jsxs(ModeIndicatorHeader, {
      $color: "fill-primary-default",
      $useGradient: use === 'preview',
      "data-test-id": dataTestId,
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-y-0",
        children: modeTitle
      }), /*#__PURE__*/_jsx(UICloseButton, {
        onClick: onCancel,
        size: "medium"
      })]
    })]
  });
};
export default ModeIndicator;